// purchases-misc-messages translations (English catalog).
window.PlummeI18n.register('en', {
  'r1p.docs.movedToTrash': 'Document moved to the trash.',
  'r1p.docs.moveFailed': 'Could not move the document.',
  'r1p.docs.restored': 'Document restored.',
  'r1p.docs.restoreFailed': 'Could not restore the document.',
  'r1p.docs.confirmDeleteOne': 'Delete the document permanently?',
  'r1p.docs.confirmDeleteMany': 'Delete the selected documents permanently?',
  'r1p.docs.deletedPermanently': 'Document permanently deleted.',
  'r1p.docs.deleteFailed': 'Could not delete the document.',
  'r1p.selectedCount': '{count} selected',
  'r1p.sale.backendNotReady': 'Backend storage is not ready.',
  'r1p.sale.lineRequired': 'Add at least one sales line.',
  'r1p.manual.noAccountMatch': 'No account matches “{query}”.',
  'r1p.picker.searchPlaceholder': 'Search name, number or e.g. 4300',
  'r1p.picker.favorite': 'Favorite',
});
